import type { CarouselItems } from './Carousel'

const MAX_VISIBLE_DOTS_PRODUCT_CARD = 3
const DOT_SLOT_WIDTH = 24

type DotsProps = {
  items: CarouselItems
  currentIndex: number
  handleClick: (index: number) => void
  variant?: 'default' | 'product-card'
}

const getSlidingStartIndex = (current: number, total: number) => {
  if (total <= MAX_VISIBLE_DOTS_PRODUCT_CARD) {
    return 0
  }

  if (current <= 1) {
    return 0
  }

  if (current >= total - 2) {
    return total - MAX_VISIBLE_DOTS_PRODUCT_CARD
  }

  return current - 1
}

const Dots = ({
  items,
  currentIndex,
  handleClick,
  variant = 'default',
}: DotsProps) => {
  const isProductCardSlidingDots = variant === 'product-card'
  const startIndex = isProductCardSlidingDots
    ? getSlidingStartIndex(currentIndex, items.length)
    : 0

  const dotsTrackStyle = isProductCardSlidingDots
    ? {
        transform: `translateX(-${startIndex * DOT_SLOT_WIDTH}px)`,
      }
    : undefined

  return (
    <div
      className={`carousel-dots ${
        isProductCardSlidingDots ? 'carousel-dots--product-card-sliding' : ''
      }`}
      role="group"
      aria-label="Navegação por pontos do carrossel"
    >
      <div className="carousel-dots-window">
        <div className="carousel-dots-track" style={dotsTrackStyle}>
          {items?.map((_, index) => {
            const isVisible =
              !isProductCardSlidingDots ||
              (index >= startIndex &&
                index < startIndex + MAX_VISIBLE_DOTS_PRODUCT_CARD)

            return (
              <button
                key={index}
                className={`carousel-dot ${
                  index === currentIndex ? 'active' : ''
                } ${
                  isProductCardSlidingDots ? 'carousel-dot--product-card' : ''
                }`}
                onClick={() => handleClick(index)}
                aria-label={`Ir para o slide ${index + 1}`}
                aria-pressed={index === currentIndex}
                tabIndex={index === currentIndex ? -1 : isVisible ? 0 : -1}
              />
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default Dots
